'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { cn } from '@/lib/utils';
function ScrollArea(t0) {
  const $ = _c(23);
  let children;
  let className;
  let props;
  let scrollBarClassName;
  let thumbClassName;
  let viewportClassName;
  if ($[0] !== t0) {
    ({
      className,
      viewportClassName,
      scrollBarClassName,
      thumbClassName,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = scrollBarClassName;
    $[5] = thumbClassName;
    $[6] = viewportClassName;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    scrollBarClassName = $[4];
    thumbClassName = $[5];
    viewportClassName = $[6];
  }
  let t1;
  if ($[7] !== className) {
    t1 = cn("relative min-h-0 overflow-hidden", className);
    $[7] = className;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== viewportClassName) {
    t2 = cn("focus-visible:ring-ring/50 w-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1", viewportClassName);
    $[9] = viewportClassName;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children || $[12] !== t2) {
    t3 = <ScrollAreaPrimitive.Viewport data-slot="scroll-area-viewport" className={t2}>{children}</ScrollAreaPrimitive.Viewport>;
    $[11] = children;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== scrollBarClassName || $[15] !== thumbClassName) {
    t4 = <ScrollBar className={scrollBarClassName} thumbClassName={thumbClassName} />;
    $[14] = scrollBarClassName;
    $[15] = thumbClassName;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollAreaPrimitive.Corner />;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== props || $[19] !== t1 || $[20] !== t3 || $[21] !== t4) {
    t6 = <ScrollAreaPrimitive.Root data-slot="scroll-area" className={t1} {...props}>{t3}{t4}{t5}</ScrollAreaPrimitive.Root>;
    $[18] = props;
    $[19] = t1;
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}
function ScrollBar(t0) {
  const $ = _c(18);
  let className;
  let props;
  let t1;
  let thumbClassName;
  if ($[0] !== t0) {
    ({
      className,
      thumbClassName,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = thumbClassName;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    thumbClassName = $[4];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const t2 = orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent";
  const t3 = orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent";
  let t4;
  if ($[5] !== className || $[6] !== t2 || $[7] !== t3) {
    t4 = cn("flex touch-none p-px transition-colors select-none", t2, t3, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== thumbClassName) {
    t5 = cn("bg-border relative flex-1 rounded-xs", thumbClassName);
    $[9] = thumbClassName;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <ScrollAreaPrimitive.ScrollAreaThumb data-slot="scroll-area-thumb" className={t5} />;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== orientation || $[14] !== props || $[15] !== t4 || $[16] !== t6) {
    t7 = <ScrollAreaPrimitive.ScrollAreaScrollbar data-slot="scroll-area-scrollbar" orientation={orientation} className={t4} {...props}>{t6}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[13] = orientation;
    $[14] = props;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export { ScrollArea, ScrollBar };